import { motion } from "framer-motion";
import { Star } from "lucide-react";

const REVIEWS = [
    { name: "Maya R.", context: "Commutes daily", text: "I clip it to the lanyard around my neck on the metro and it genuinely makes rush hour bearable. The cold plate on my wrist is a game changer.", stars: 5 },
    { name: "Daniel K.", context: "Works from home", text: "Sits on my desk all day on speed 20-something. Quiet enough for calls, and I charge it maybe every other day.", stars: 5 },
    { name: "Sofia L.", context: "Student", text: "Bought it for the library. The digital display is weirdly satisfying and it doesn't disturb anyone around me.", stars: 4 },
    { name: "James T.", context: "Festival goer", text: "Took it to a 3-day outdoor festival. Speed 100 in the afternoon sun felt like having my own weather system.", stars: 5 },
    { name: "Priya N.", context: "Traveler", text: "Fits in the side pocket of my backpack. Used it through two airports and a long layover on one charge.", stars: 5 },
    { name: "Leo M.", context: "Night-shift nurse", text: "The cold plate on the back of my neck during breaks is the fastest reset I've found. Battery easily lasts a full shift.", stars: 4 },
];

const Stars = ({ n }) => (
    <div className="flex gap-1 mb-4">
        {Array.from({ length: 5 }).map((_, i) => (
            <Star key={i} className={`w-3.5 h-3.5 ${i < n ? "text-cyan-300 fill-cyan-300" : "text-zinc-700"}`} />
        ))}
    </div>
);

export default function Reviews() {
    return (
        <section id="reviews" data-testid="reviews-section" className="max-w-7xl mx-auto px-5 md:px-10 py-24 md:py-32">
            <motion.p
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7 }}
                className="text-xs uppercase tracking-[0.3em] text-cyan-300 mb-3"
            >
                Early feedback
            </motion.p>
            <motion.h2
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: 0.1 }}
                className="font-display uppercase font-700 tracking-tighter text-4xl md:text-6xl mb-14"
            >
                Cool heads <span className="text-cyan-300">prevail.</span>
            </motion.h2>

            <div className="columns-1 md:columns-2 lg:columns-3 gap-6 space-y-6">
                {REVIEWS.map((r, idx) => (
                    <motion.figure
                        key={r.name}
                        initial={{ opacity: 0, y: 40 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ duration: 0.8, delay: (idx % 3) * 0.08 }}
                        data-testid={`review-card-${idx}`}
                        className="break-inside-avoid rounded-[1.5rem] border border-white/10 bg-white/[0.03] p-7 hover:border-cyan-300/30 transition-colors duration-500"
                    >
                        <Stars n={r.stars} />
                        <blockquote className="text-sm md:text-base text-zinc-300 leading-relaxed">“{r.text}”</blockquote>
                        <figcaption className="mt-5 flex items-center gap-3">
                            <span className="w-9 h-9 rounded-full bg-cyan-300/15 border border-cyan-300/30 flex items-center justify-center font-display text-cyan-300 text-sm">
                                {r.name[0]}
                            </span>
                            <div>
                                <p className="text-sm font-semibold">{r.name}</p>
                                <p className="text-xs text-zinc-500">{r.context}</p>
                            </div>
                        </figcaption>
                    </motion.figure>
                ))}
            </div>
        </section>
    );
}
